/* eslint-disable max-len */
import AttributeValueSuggestorFactory from "./AttributeValueSuggestorFactory.js";
export default {
  getAttributeValueSuggestorFor(attribute, opts) {
    let suggestor = AttributeValueSuggestorFactory.create(`${attribute.objectType}.${attribute.name}`, opts);
    suggestor = suggestor || AttributeValueSuggestorFactory.create(`${attribute.objectType}.${attribute.valueType}`, opts);
    return suggestor;
  }
};